import React from "react";
import UKFlag from "../../assets/uk-flag.svg";

export default function FoxIcon({ size }) {
  return <img src={UKFlag} width={size} />;
}
